import { Box, ButtonBase, Card, Typography } from "@mui/material"
import { Else, If } from "lib/@components/switch"
import { getSpaceTilePresentation } from "./space-tile-presentation"
import { useEffect, useRef, useState } from "react"

export function SpaceTile({ space, onClick }) {
    const [failedImage, setFailedImage] = useState()
    const [loadedImage, setLoadedImage] = useState()
    const imageContainerRef = useRef()
    const imageRef = useRef()
    const presentation = getSpaceTilePresentation(space, failedImage, loadedImage)
    useEffect(checkImageAfterRender, [space.image])

    return (
        <ButtonBase
            color="primary"
            sx={{ flex: presentation.buttonFlex, width: 1, display: "flex", flexDirection: "column" }}
            aria-label={`Choose ${space.name}`}
            onClick={onClick}
        >
            <Card
                data-cy={`space-card-${space.name?.toLowerCase().split(" ").join("-")}`}
                sx={{
                    width: 1,
                    textAlign: "center",
                    cursor: "pointer",
                    flex: presentation.buttonFlex,
                    alignSelf: "stretch",
                    display: "flex",
                    flexDirection: "column",
                    position: "relative",
                    pb: presentation.cardPaddingBottom,
                    transition: presentation.transition,
                }}
            >
                <If truthy={presentation.variant === "image"}>
                    <Box width={1} sx={{ position: "relative" }} ref={imageContainerRef}>
                        <Box
                            width={1}
                            component="img"
                            border="none"
                            ref={imageRef}
                            onError={handleImageError}
                            onLoad={handleImageLoad}
                            sx={{
                                objectFit: "cover",
                                opacity: presentation.imageOpacity,
                                transition: presentation.transition,
                            }}
                            src={space.image}
                            bgcolor={presentation.accentColor}
                            height={presentation.accentLineHeight}
                            color="#333"
                            overflow="hidden"
                        />
                    </Box>
                    <Else>
                        <Box sx={{ height: presentation.accentLineHeight, bgcolor: presentation.accentColor }} />
                    </Else>
                </If>
                <Box sx={{ px: 2, py: presentation.contentPaddingY }}>
                    <Typography
                        variant="subtitle1"
                        sx={{ mt: presentation.titleMarginTop, transition: presentation.transition }}
                    >
                        {space.name ?? "Not named"}
                    </Typography>
                    <Typography variant="body2" sx={{ color: "text.secondary" }}>
                        {space.location ?? ""}
                    </Typography>
                </Box>
            </Card>
        </ButtonBase>
    )

    function handleImageError() {
        setFailedImage(space.image)
        setLoadedImage()
    }

    function handleImageLoad(event) {
        markImageLoadedWhenUsable(event.currentTarget)
    }

    function checkImageAfterRender() {
        if (!space.image) return undefined
        checkLoadedImage()
        const interval = setInterval(checkLoadedImage, 250)
        const timeout = setTimeout(stopCheckingImage, 15000)
        return cleanUpImageCheck

        function stopCheckingImage() {
            clearInterval(interval)
        }

        function cleanUpImageCheck() {
            clearInterval(interval)
            clearTimeout(timeout)
        }
    }

    function checkLoadedImage() {
        const image = imageRef.current ?? imageContainerRef.current?.querySelector("img")
        if (!image?.complete) return
        markImageLoadedWhenUsable(image)
    }

    function markImageLoadedWhenUsable(image) {
        if (image.naturalWidth > 0 && image.naturalHeight > 0) {
            setLoadedImage(space.image)
            return
        }
        setFailedImage(space.image)
        setLoadedImage()
    }
}
